import { localStorageVariableName } from "swfrontend/AppConfigs";
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";
import getCookie from "swfrontend/COMS/Utils/cookies";
import {
  STANDARD_METHOD_OPTIONS,
  CACHE_SETTINGS,
  CORS_SETTINGS,
  HEADER_JSON,
} from "../Configs/AppConfigs";

export default class ApiHelper {
  baseUrl = null;

  constructor(baseUrl) {
    this.baseUrl = baseUrl;
  }

  apiCall = (url, method, values) => {
    if (values && values.constructor.name !== "FormData") {
      values = JSON.stringify(values);
      HEADER_JSON["Content-Type"] = "application/json";
    } else {
      delete HEADER_JSON["Content-Type"];
    }
    let auth = null;
    if (
      window.location.pathname.includes("ApprovalForm") &&
      sessionStorage.getItem(localStorageVariableName.userName) !== null &&
      sessionStorage.getItem("auth-token-mail") !== null
    ) {
      auth = JSON.parse(sessionStorage.getItem("auth-token-mail"));
    } else {
      auth = JSON.parse(
        localStorage.getItem(`${process.env.REACT_APP_TOKEN_PREFIX}-auth-token`)
      );
    }
    return fetch(this.baseUrl + url, {
      ...STANDARD_METHOD_OPTIONS,
      ...CACHE_SETTINGS,
      ...CORS_SETTINGS,
      method: method,
      headers: {
        ...HEADER_JSON,
        "X-CSRFToken": getCookie(
          `${process.env.REACT_APP_TOKEN_PREFIX}-csrftoken`
        ),
        Authorization: auth,
      },
      body: values != null ? values : null,
    }).then((res) => {
      if (res.status === 401) {
        localStorage.clear();
        openNotification(
          "error",
          "LOGIN EXPIRED",
          "Your session has expired. Please login again"
        );
        setTimeout(() => {
          window.location =
            process.env.REACT_APP_PROJECT_ROUTE === "/null"
              ? ""
              : process.env.REACT_APP_PROJECT_ROUTE;
        }, 2500);
      } else if (res.status === 403) {
        openNotification(
          "error",
          "Authorization",
          "You do not have permission to perform this action."
        );
      }
      return res;
    });
  };

}
